namespace Matrix.Workflow {
    export interface ApprovalRetrieveRequest extends Serenity.ServiceRequest {
        WorkflowInstanceId?: number;
    }
}
